import React from 'react'

function NotFound ({ TEXT, Status }) {
  return (
    <section class='collection-explore maintainance-sec'>
      <div class='overlay position-relative' style={{ height: '100vh' }}>
        <div
          class='content-m text-center'
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <h1
            class='mb-5 text-light'
            style={{
              fontSize: '90px',
              lineHeight: '60px',
              fontFamily: 'var(--body-hd-font)'
            }}
          >
            {' '}
            {Status}
          </h1>
          <h3 class='text-light'>{TEXT || 'Page Not Found'}</h3>
          <a href='/' class='btn btn btnm-primary mt-3 px-4'>
            Go Back Home
          </a>
        </div>
      </div>
    </section>
  )
}

export default NotFound
